import React, { Component } from 'react'
import PropTypes from 'prop-types'

import _ from 'lodash'

import BisnodeScoring from './components/BisnodeScoring'
import PaymentIndex from './components/PaymentIndex'
import Distraints from './components/Distraints'
import Indicator from './components/Indicator'

import './style.scss'

export default class Indicators extends Component {
    static propTypes = {
        data: PropTypes.object,
        level: PropTypes.string.isRequired,
        onClickHandler: PropTypes.func,
        translates: PropTypes.shape({
            bisnodeScoringTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            bisnodeScoringTootlip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
            debtsTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            debtsTooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
            distraintsTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            distraintsTooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
            insolvencyTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            insolvencyTooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
            liquidationTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            liquidationTooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
            paymentIndexTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            paymentIndexTooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
            vatTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            vatTooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
            activeMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            historicalMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            noMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            naDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }),
    }

    clickHandler = (identifier) => {
        const { onClickHandler, data } = this.props

        if (onClickHandler) onClickHandler(identifier, data)
    }

    render() {
        const {
            data,
            translates: {
                bisnodeScoringTitle,
                debtsTitle,
                distraintsTitle,
                insolvencyTitle,
                liquidationTitle,
                paymentIndexTitle,
                vatTitle,
                activeMessage,
                historicalMessage,
                noMessage,
                bisnodeScoringTootlip,
                debtsTooltip,
                distraintsTooltip,
                insolvencyTooltip,
                liquidationTooltip,
                paymentIndexTooltip,
                vatTooltip,
                naDescription,
            },
        } = this.props

        if (!data) return null

        const {
            data: {
                bisnodeScoring,
                bisnodeScoringLight,
                paymentIndex,
                paymentIndexLight,
                insolvency,
                liquidation,
                vat,
                debt,
                distraint,
                registeredDistraint,
            },
            level,
        } = this.props

        const [parsedLevel] = level
            .split(',')
            .map((x) => parseInt(x, 10))
            .slice(-1)

        return (
            <div className={'block-indicators'}>
                {parsedLevel > 10 && (
                    <BisnodeScoring
                        headerMessage={bisnodeScoringTitle}
                        identifier={'bisnodeScoring'}
                        clickIdentifier={'bisnodeScoring'}
                        data={parsedLevel < 50 ? bisnodeScoringLight : bisnodeScoring}
                        isLight={parsedLevel < 50}
                        noMessage={noMessage}
                        tooltip={bisnodeScoringTootlip}
                        clickHandler={this.clickHandler}
                        naDescription={naDescription}
                    />
                )}
                {parsedLevel > 10 && (
                    <PaymentIndex
                        headerMessage={paymentIndexTitle}
                        identifier={'paymentIndex'}
                        clickIdentifier={'paymentIndex'}
                        data={parsedLevel < 50 ? paymentIndexLight : paymentIndex}
                        isLight={parsedLevel < 50}
                        noMessage={noMessage}
                        paymentRiskIndicator={paymentIndex ? paymentIndex.riskIndicator : false}
                        tooltip={paymentIndexTooltip}
                        clickHandler={this.clickHandler}
                        naDescription={naDescription}
                    />
                )}
                <Indicator
                    headerMessage={insolvencyTitle}
                    identifier={'insolvency'}
                    clickIdentifier={'negativeEvents'}
                    activeValue={_.get(insolvency, 'active.hasAny')}
                    historicalValue={_.get(insolvency, 'inactive.hasAny')}
                    noMessage={noMessage}
                    activeValueMessage={activeMessage}
                    historicalValueMessage={historicalMessage}
                    tooltip={insolvencyTooltip}
                    clickHandler={this.clickHandler}
                />
                <Indicator
                    headerMessage={liquidationTitle}
                    identifier={'liquidation'}
                    clickIdentifier={'negativeEvents'}
                    activeValue={_.get(liquidation, 'active.hasAny')}
                    historicalValue={_.get(liquidation, 'inactive.hasAny')}
                    activeValueMessage={activeMessage}
                    historicalValueMessage={historicalMessage}
                    noMessage={noMessage}
                    tooltip={liquidationTooltip}
                    clickHandler={this.clickHandler}
                />
                <Indicator
                    headerMessage={vatTitle}
                    identifier={'vat'}
                    clickIdentifier={'negativeEvents'}
                    activeValue={_.get(vat, 'active.hasAny')}
                    historicalValue={_.get(vat, 'inactive.hasAny')}
                    activeValueMessage={activeMessage}
                    historicalValueMessage={historicalMessage}
                    noMessage={noMessage}
                    tooltip={vatTooltip}
                    clickHandler={this.clickHandler}
                />
                <Distraints
                    headerMessage={distraintsTitle}
                    identifier={'distraints'}
                    clickIdentifier={'negativeEvents'}
                    distraintsActive={_.get(distraint, 'active.hasAny') || _.get(registeredDistraint, 'active.hasAny')}
                    distraintsPaidActive={
                        _.get(distraint, 'active.hasAny') || _.get(registeredDistraint, 'active.hasAny')
                    }
                    distraintsHistorical={
                        _.get(distraint, 'inactive.hasAny') || _.get(registeredDistraint, 'inactive.hasAny')
                    }
                    distraintsActiveMessage={activeMessage}
                    distraintsHistoricalMessage={historicalMessage}
                    noMessage={noMessage}
                    tooltip={distraintsTooltip}
                    clickHandler={this.clickHandler}
                />
                <Indicator
                    headerMessage={debtsTitle}
                    identifier={'debt'}
                    clickIdentifier={'negativeEvents'}
                    activeValue={_.get(debt, 'active.hasAny')}
                    historicalValue={_.get(debt, 'inactive.hasAny')}
                    activeValueMessage={activeMessage}
                    historicalValueMessage={historicalMessage}
                    noMessage={noMessage}
                    tooltip={debtsTooltip}
                    riskIndicator={_.get(debt, 'riskIndicator')}
                    clickHandler={this.clickHandler}
                />
            </div>
        )
    }
}
